import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4d05d67a&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./assets/common.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=4d05d67a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05d67a",
  null
  
)

export default component.exports